import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import Paragraph from 'components/Paragraph';
import classes from './Loading.module.scss';

const Loading = ({ children }) => (
  <div>
    <div className={classes.loading}>
      <div className={classes.loadingMessageContainer}>
        <FontAwesomeIcon icon={faSpinner} size="2x" spin />
        <Paragraph>{children}</Paragraph>
      </div>
    </div>
  </div>
);

Loading.defaultProps = {
  children: 'Cargando...',
};

Loading.propTypes = {
  children: PropTypes.string,
};

export default Loading;
